import React from 'react';
import { Link } from 'react-router-dom';
import MetaData from './MetaData';

const ComingSoon = () => (
  <>
    <MetaData title="Coming Soon" />
    <div className="row wrapper" style={{ minHeight: '70vh' }}>
      <div className="col-10 col-lg-6 text-center">
        <div className="card p-5">
          <h1 className="display-4 fw-bold text-info mb-3">🚀 Coming Soon</h1>
          <p className="text-muted mb-4">
            We're working on something exciting! This feature will be available shortly.
          </p>
          <div className="mb-4">
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <Link to="/" className="btn btn-primary py-2 px-4 fw-semibold">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default ComingSoon;